/* eslint-disable no-use-before-define */

const EVENEMENTS_OUVERTURE = {
  startUtilisateur: 'CAPTURE_BUTTON_START_REQUESTED',
};

const EVENEMENTS_FERMETURE = {
  stopUserConfirmed: 'STOP_USER_CONFIRMED',
  finalizeReceived: 'FINALIZE_RECEIVED',
  cameraFinalizeOk: 'CAMERA_FINALIZE_OK',
};

const FLUX_INTERPRETES_SESSION = [
  {
    id: 'flux:capture-raw',
    nom: 'Capture -> RAW',
    mission: 'un segment RAW exploitable est produit et ferme proprement',
  },
  {
    id: 'flux:av-sync',
    nom: 'AV_SYNC',
    mission: 'la derive audio/video du segment est mesuree, qualifiee et rendue exploitable',
  },
  {
    id: 'flux:raw-decoupe',
    nom: 'RAW -> Decoupe',
    mission: 'une video decoupee exploitable est produite et reliee au RAW source',
  },
];

const SEUIL_DERIVE_AV_IMPACT_CLIENT_SEC = 3;
const SEUIL_DERIVE_AV_TEMPS_REEL_SEC = 0.5;
const SEUIL_AMPLITUDE_OSCILLATION_AV_SEC = SEUIL_DERIVE_AV_TEMPS_REEL_SEC;

function calculerSessions(source = {}, options = {}) {
  const periode = options.periode || {};
  const bouclesObservees = options.bouclesObservees || [];
  const debug = options.debugSessions === true;
  const signauxBruts = collecterSignauxSession(source);
  console.warn(
    '[COLLECT_OUTPUT]',
    {
      nb: signauxBruts.length,
      sample: signauxBruts.slice(0,5)
    }
  );
  const signaux = signauxBruts
    .filter((signal) => signal.cameraId && signal.timestampMs)
    .sort((a, b) => a.timestampMs - b.timestampMs);

  console.warn(
    '[SESSION_OPEN_CANDIDATS]',
    signaux
      .slice(0, 100)
      .map((s) => ({
        type: s.type,
        evenement_type: s.evenement_type,
        reason: s.reason,
        transitionReason: s.transitionReason,
        raw: s.payload,
      }))
  );

  console.warn(
    '[SESSION_START_STATS]',
    {
      total: signaux.length,
      startCandidates:
        signaux.filter(
          (s) => JSON.stringify(s)
            .toLowerCase()
            .includes('capture')
        ).length,
      types:
        [...new Set(signaux.map((s) => s.type))],
    }
  );

  const sessions = [];
  const activesParCamera = new Map();
  const fermeesRecentesParCamera = new Map();

  signaux.forEach((signal) => {
    const cameraId = signal.cameraId;
    let active = activesParCamera.get(cameraId);

    if (!active && signal.type !== EVENEMENTS_OUVERTURE.startUtilisateur) {
      const fermee = fermeesRecentesParCamera.get(cameraId);
      if (fermee && signal.timestampMs >= fermee.finMs && signal.timestampMs - fermee.finMs <= 5 * 60 * 1000) {
        rattacherSignal(fermee.session, signal);
        if (signal.type === EVENEMENTS_FERMETURE.stopUserConfirmed) fermee.session.signaux.stopUserConfirmed = true;
        if (signal.type === EVENEMENTS_FERMETURE.cameraFinalizeOk) fermee.session.signaux.cameraFinalizeOk = true;
      }
    }

    if (signal.type === EVENEMENTS_OUVERTURE.startUtilisateur) {
      if (active) {
        fermerSession(active, signal.timestampMs, 'nouveau_demarrage_utilisateur', 'moyenne', 'fermee');
        journaliserRegleSession('CLOSE_IMPLICIT', active);
        sessions.push(active);
      }
      active = creerSession(cameraId, signal, 'capture_button_start_requested', 'moyenne');
      activesParCamera.set(cameraId, active);
      journaliserRegleSession('OPEN', active);
      return;
    }

    active = activesParCamera.get(cameraId);
    if (!active) return;

    rattacherSignal(active, signal);

    if (signal.type === EVENEMENTS_FERMETURE.stopUserConfirmed) {
      active.signaux.stopUserConfirmed = true;
      fermerSession(active, signal.timestampMs, 'stop_utilisateur_confirme', 'elevee', 'fermee');
      journaliserRegleSession('CLOSE_USER', active);
      sessions.push(active);
      fermeesRecentesParCamera.set(cameraId, { session: active, finMs: signal.timestampMs });
      activesParCamera.delete(cameraId);
    } else if (signal.type === EVENEMENTS_FERMETURE.finalizeReceived) {
      active.signaux.finalizeReceived = true;
    } else if (signal.type === EVENEMENTS_FERMETURE.cameraFinalizeOk) {
      active.signaux.cameraFinalizeOk = true;
    }
  });

  activesParCamera.forEach((session) => {
    fermerSession(session, periode.finMs || session.dernierSignalMs || session.debutMs, 'absence_preuve_arret', 'faible', 'ouverte');
    journaliserRegleSession('CLOSE_TIMEOUT', session);
    session.ouverteEnFinPeriode = true;
    sessions.push(session);
  });

  const sessionsFinales = sessions
    .map((session) => finaliserSession(session, bouclesObservees, session.ouverteEnFinPeriode))
    .sort((a, b) => (timestampMs(b.startAt) || 0) - (timestampMs(a.startAt) || 0));

  if (debug) journaliserDiagnosticSessions(source, signaux, sessionsFinales);
  return sessionsFinales;
}

function collecterSignauxSession(source = {}) {
  console.warn(
    '[COLLECT_INPUT]',
    {
      keys: Object.keys(source),
      signauxSessions: source.signauxSessions ? source.signauxSessions.length : undefined
    }
  );
  const signaux = []
    .concat(source.signauxSessions || [])
    .concat(source.sessionsSignaux || [])
    .concat(source.signauxBruts || [])
    .concat(source.evenements || [])
    .concat(source.evenementsClasses || [])
    .concat(source.incidentsCritiques || source.incidents || [])
    .concat(source.fauxSuccesCritiques || source.fauxSucces || [])
    .concat(source.objetsCritiques || []);

  return signaux.map(normaliserSignalSession).filter(Boolean);
}

function journaliserDiagnosticSessions(source, signaux, sessions) {
  const diagnosticSource = diagnostiquerSourceSessions(source, signaux);
  console.log(diagnosticSource);
  console.log('[SESSION_STATS]', calculerStatsSessions(sessions));

  const cameras = new Set(signaux.map((signal) => signal.cameraId));
  sessions.forEach((session) => cameras.add(session.cameraId));
  Array.from(cameras).sort().forEach((cameraId) => {
    const signauxCamera = signaux.filter((signal) => signal.cameraId === cameraId);
    const sessionsCamera = sessions.filter((session) => session.cameraId === cameraId);
    const signalCounts = compterParType(signauxCamera);

    console.log({
      cameraId,
      nbSignaux: signauxCamera.length,
      nbCaptureStart: signalCounts.CAPTURE_BUTTON_START_REQUESTED || 0,
      nbFirstBytes: signalCounts.FIRST_BYTES || 0,
      nbFinalize: signalCounts.FINALIZE_RECEIVED || 0,
      nbSessions: sessionsCamera.length,
      firstSignalAt: signauxCamera[0] ? new Date(signauxCamera[0].timestampMs).toISOString() : null,
      lastSignalAt: signauxCamera[signauxCamera.length - 1] ? new Date(signauxCamera[signauxCamera.length - 1].timestampMs).toISOString() : null,
    });

    console.log({
      cameraId,
      signalCounts,
    });
  });
}

function diagnostiquerSourceSessions(source, signaux) {
  const sourceDetectee = source.signauxSessions && source.signauxSessions.length > 0
    ? 'A_signaux_sessions_complets'
    : source.signauxTemporels ? 'B_signaux_temporels_agreges'
      : (source.incidentsCritiques || source.incidents || []).length > 0 ? 'C_incidents_uniquement'
        : (source.journeesCamera || []).length > 0 ? 'B_projection_journee_camera'
          : 'source_vide';

  return {
    source: sourceDetectee,
    nbSignaux: signaux.length,
    typesDisponibles: Object.keys(compterParType(signaux)).sort(),
  };
}

function compterParType(signaux) {
  return (signaux || []).reduce((total, signal) => {
    total[signal.type] = (total[signal.type] || 0) + 1;
    return total;
  }, {});
}

function normaliserSignalSession(item) {
  if (!item || typeof item !== 'object') return null;
  const payload = normaliserPayload(item.payload);
  const texte = texteSignal(item, payload);
  const type = normaliserTypeEvenement(
    lirePremierChamp(item, payload, ['evenement_type', 'eventType', 'type', 'nom', 'signal', 'type_projection'])
    || texte
  );
  const timestamp = lirePremierChamp(item, payload, ['ts_event', 'timestamp', 'timestampAt', 'recu_at', 'dernier_observe_at', 'derniere_preuve_utile_at']);
  const cameraId = lirePremierChamp(item, payload, ['cam_id', 'camId', 'cameraId', 'camera_id', 'tel_id', 'telId']);

  const tsMs = timestampMs(timestamp);
  if (!type || !timestamp || !cameraId || !tsMs) return null;

  return {
    brut: item,
    payload,
    texte,
    type,
    timestamp,
    timestampMs: tsMs,
    cameraId: String(cameraId),
    driftSec: lireDriftSec(item, payload, texte),
  };
}

function normaliserTypeEvenement(valeur) {
  const texte = String(valeur || '').toUpperCase();
  const alias = [
    ['CAPTURE_BUTTON_START_REQUESTED', ['CAPTURE_BUTTON_START_REQUESTED']],
    ['CAMERA_DEMARRAGE_DEMANDE', ['CAMERA_DEMARRAGE_DEMANDE', 'DEMANDE_DEMARRAGE_CAPTURE']],
    ['STOP_USER_CONFIRMED', ['STOP_USER_CONFIRMED', 'ARRET_UTILISATEUR_CONFIRME', 'STOP_CONFIRME_UTILISATEUR']],
    ['FINALIZE_RECEIVED', ['FINALIZE_RECEIVED', 'FINALIZE_RECU', 'FINALIZE_REQUEST_RECEIVED']],
    ['CAMERA_FINALIZE_OK', ['CAMERA_FINALIZE_OK', 'FINALIZE_OK_CAMERA']],
    ['CAMERA_FINALIZE_ERREUR', ['CAMERA_FINALIZE_ERREUR', 'FINALIZE_ERREUR_CAMERA']],
    ['CAMERA_FINALIZE_VIDE', ['CAMERA_FINALIZE_VIDE', 'FINALIZE_VIDE_CAMERA', 'RAW_VIDE']],
    ['CAMERA_CRASH', ['CAMERA_CRASH']],
    ['AV_SYNC_AUDIT', ['AV_SYNC_AUDIT']],
    ['AV_SYNC_WALL_CLOCK_DRIFT', ['AV_SYNC_WALL_CLOCK_DRIFT']],
    ['FIRST_BYTES', ['FIRST_BYTES', 'FIRST_BYTES_SEGMENT', 'CAMERA_PREMIERS_OCTETS']],
    ['START', ['START']],
    ['CAMERA_RECORD_START', ['CAMERA_RECORD_START']],
    ['RESTART_REQUEST', ['RESTART_REQUEST']],
    ['CAMERA_RECOVERY_START', ['CAMERA_RECOVERY_START']],
  ];
  const trouve = alias.find(([, valeurs]) => valeurs.some((nom) => texte.includes(nom)));
  return trouve ? trouve[0] : '';
}

function creerSession(cameraId, signal, raisonOuverture, confianceInitiale) {
  const session = {
    cameraId,
    sessionId: `session-${cameraId}-${signal.timestampMs}`,
    startAt: new Date(signal.timestampMs).toISOString(),
    endAt: '',
    durationSec: 0,
    confidence: confianceInitiale,
    statut: 'ouverte',
    raisonOuverture,
    resume: {
      qualiteGlobale: 'donnees_insuffisantes',
      capture: 'Demarrage observe.',
      decoupe: 'Donnees insuffisantes',
      transport: 'Donnees insuffisantes',
      temps: 'Donnees insuffisantes',
    },
    boucles: [],
    flux: [],
    signaux: {
      start: raisonOuverture === 'capture_button_start_requested',
      stopUserConfirmed: false,
      finalizeReceived: false,
      cameraFinalizeOk: false,
    },
    metrics: {},
    signauxBruts: [],
    debutMs: signal.timestampMs,
    dernierSignalMs: signal.timestampMs,
  };
  rattacherSignal(session, signal);
  return session;
}

function rattacherSignal(session, signal) {
  session.dernierSignalMs = Math.max(session.dernierSignalMs || 0, signal.timestampMs);
  session.signauxBruts.push(signal);

  if (signal.type === 'AV_SYNC_AUDIT' || signal.type === 'AV_SYNC_WALL_CLOCK_DRIFT') {
    session.flux.push({
      type: signal.type,
      at: new Date(signal.timestampMs).toISOString(),
      driftSec: signal.driftSec,
    });
  }
}

function fermerSession(session, finMs, raisonFermeture, confiance, statut) {
  const fin = Math.max(finMs || 0, session.debutMs || 0);
  session.endAt = new Date(fin).toISOString();
  session.durationSec = Math.max(0, Math.round((fin - session.debutMs) / 1000));
  session.raisonFermeture = raisonFermeture;
  if (confiance) session.confidence = confiance;
  if (statut) session.statut = statut;
}

function journaliserRegleSession(action, session) {
  console.log('[SESSION_RULE]', action, {
    cameraId: session.cameraId,
    sessionId: session.sessionId,
    reason: session.raisonFermeture || session.raisonOuverture,
    confidence: session.confidence,
    durationMin: Math.round((Number(session.durationSec || 0) / 60) * 10) / 10,
  });
}

function finaliserSession(session, bouclesObservees, ouverteEnFinPeriode = false) {
  const complete = {
    ...session,
    signauxBruts: session.signauxBruts.map(serialiserSignalSession).filter(Boolean),
  };

  complete.confidence = calculerConfiance(complete, ouverteEnFinPeriode);
  complete.metrics = calculerMetricsSession(complete);
  complete.hasStart = Boolean(complete.signaux.start);
  complete.hasStop = Boolean(complete.signaux.stopUserConfirmed);
  complete.hasFinalize = Boolean(complete.signaux.finalizeReceived);
  complete.hasFinalizeOk = Boolean(complete.signaux.cameraFinalizeOk);
  complete.hasAvAudit = Boolean(complete.metrics.nbAuditsAv > 0);
  complete.microSession = estMicroSession(complete);
  complete.boucles = rattacherBouclesSession(complete, bouclesObservees);
  complete.resume = resumerSession(complete, ouverteEnFinPeriode);
  complete.diagnosticsMoteur = diagnostiquerFluxSession(complete);

  delete complete.debutMs;
  delete complete.dernierSignalMs;
  delete complete.ouverteEnFinPeriode;
  console.warn(
    '[SESSION_RETURN]',
    {
      av: complete.metrics && complete.metrics.av,
      resume: complete.resume && complete.resume.av,
    }
  );
  return complete;
}

function calculerConfiance(session, ouverteEnFinPeriode) {
  if (session.raisonFermeture === 'stop_utilisateur_confirme') return 'elevee';
  if (session.raisonFermeture === 'nouveau_demarrage_utilisateur') return 'moyenne';
  if (session.raisonFermeture === 'absence_preuve_arret' || ouverteEnFinPeriode) return 'faible';
  return 'faible';
}

function calculerMetricsSession(session) {
  const auditsAv = session.signauxBruts
    .filter((signal) => signal.type === 'AV_SYNC_AUDIT' || signal.type === 'AV_SYNC_WALL_CLOCK_DRIFT')
    .filter((signal) => {
      console.warn(
        '[AV_AUDIT_FILTER]',
        {
          total: session.signauxBruts.length,
          audits:
            session.signauxBruts
              .filter((s) => s.type === 'AV_SYNC_AUDIT')
              .slice(0, 5)
              .map((s) => ({
                type: s.type,
                driftSec: s.driftSec,
                payload: s.payload,
              })),
        }
      );
      return Number.isFinite(signal.driftSec);
    });

  const metrics = {
    nbSignaux: session.signauxBruts.length,
    nbAuditsAv: auditsAv.length,
  };

  if (auditsAv.length > 0) {
    metrics.av = calculerMetricsAv(auditsAv);
  }

  console.warn(
    '[AV_METRICS]',
    {
      nbAudits: auditsAv.length,
      metricsAv: metrics.av,
    }
  );

  return metrics;
}

function estMicroSession(session) {
  return Number(session.durationSec || 0) < 300
    && (session.signauxBruts || []).length <= 5
    && !session.signaux.stopUserConfirmed
    && !session.signaux.finalizeReceived;
}

function consoliderSessions(sessions = []) {
  const ordonnees = [...(sessions || [])]
    .sort((a, b) => (timestampMs(a.startAt) || 0) - (timestampMs(b.startAt) || 0));
  const consolidees = [];

  ordonnees.forEach((session) => {
    const precedente = consolidees[consolidees.length - 1];
    if (precedente && peutFusionnerSessions(precedente, session)) {
      consolidees[consolidees.length - 1] = fusionnerSessions(precedente, session);
      return;
    }
    consolidees.push({
      ...session,
      sessionsFusionnees: [session],
    });
  });

  return consolidees.sort((a, b) => (timestampMs(b.startAt) || 0) - (timestampMs(a.startAt) || 0));
}

function peutFusionnerSessions(a, b) {
  if (!a || !b) return false;
  if (a.cameraId !== b.cameraId) return false;
  const finA = timestampMs(a.endAt);
  const debutB = timestampMs(b.startAt);
  if (!finA || !debutB) return false;
  const gapSec = (debutB - finA) / 1000;
  if (gapSec < 0 || gapSec > 60) return false;
  if (contientFinalize(a) || contientFinalize(b)) return false;
  if (fermetureConfianceElevee(a)) return false;
  return true;
}

function contientFinalize(session) {
  if (session.signaux && (session.signaux.finalizeReceived || session.signaux.cameraFinalizeOk)) return true;
  return (session.signauxBruts || []).some((signal) => /^FINALIZE/.test(String(signal.type || '')) || signal.type === 'CAMERA_FINALIZE_OK');
}

function fermetureConfianceElevee(session) {
  return session.confidence === 'elevee'
    || Boolean(session.signaux && session.signaux.stopUserConfirmed && session.signaux.finalizeReceived && session.signaux.cameraFinalizeOk);
}

function fusionnerSessions(a, b) {
  const sessionsFusionnees = (a.sessionsFusionnees || [a]).concat(b.sessionsFusionnees || [b]);
  const signauxBruts = sessionsFusionnees.reduce((total, session) => total.concat(session.signauxBruts || []), []);
  const flux = unirFlux(sessionsFusionnees.reduce((total, session) => total.concat(session.flux || []), []));
  const boucles = unirBoucles(sessionsFusionnees.reduce((total, session) => total.concat(session.boucles || []), []));
  const signaux = {
    start: sessionsFusionnees.some((session) => session.signaux && session.signaux.start),
    stopUserConfirmed: sessionsFusionnees.some((session) => session.signaux && session.signaux.stopUserConfirmed),
    finalizeReceived: sessionsFusionnees.some((session) => session.signaux && session.signaux.finalizeReceived),
    cameraFinalizeOk: sessionsFusionnees.some((session) => session.signaux && session.signaux.cameraFinalizeOk),
  };
  const consolidee = {
    ...a,
    sessionId: `${a.sessionId}--${b.sessionId}`,
    endAt: b.endAt,
    durationSec: Math.max(0, Math.round(((timestampMs(b.endAt) || timestampMs(b.startAt) || 0) - (timestampMs(a.startAt) || 0)) / 1000)),
    signaux,
    signauxBruts,
    flux,
    boucles,
    sessionsFusionnees,
    microSession: sessionsFusionnees.every((session) => session.microSession),
  };

  consolidee.metrics = calculerMetricsSession(consolidee);
  consolidee.hasStart = Boolean(signaux.start);
  consolidee.hasStop = Boolean(signaux.stopUserConfirmed);
  consolidee.hasFinalize = Boolean(signaux.finalizeReceived);
  consolidee.hasFinalizeOk = Boolean(signaux.cameraFinalizeOk);
  consolidee.hasAvAudit = Boolean(consolidee.metrics.nbAuditsAv > 0);
  consolidee.confidence = calculerConfiance(consolidee, false);
  consolidee.resume = resumerSession(consolidee, false);
  consolidee.diagnosticsMoteur = diagnostiquerFluxSession(consolidee);
  console.warn(
    '[SESSION_RETURN]',
    {
      av: consolidee.metrics && consolidee.metrics.av,
      resume: consolidee.resume && consolidee.resume.av,
    }
  );
  return consolidee;
}

function unirFlux(flux) {
  const vus = new Set();
  return (flux || []).filter((item) => {
    const cle = `${item.type || ''}|${item.at || ''}|${item.driftSec || ''}`;
    if (vus.has(cle)) return false;
    vus.add(cle);
    return true;
  });
}

function unirBoucles(boucles) {
  const vus = new Set();
  return (boucles || []).filter((boucle, index) => {
    const cle = String(boucle.id || boucle.nom || index);
    if (vus.has(cle)) return false;
    vus.add(cle);
    return true;
  });
}

function calculerStatsSessions(sessions) {
  const durees = [...(sessions || [])]
    .map((session) => Number(session.durationSec || 0))
    .sort((a, b) => a - b);

  return {
    nbSessions: sessions.length,
    p50Duration: percentile(durees, 0.5),
    p95Duration: percentile(durees, 0.95),
    sessionsMoins5min: sessions.filter((session) => Number(session.durationSec || 0) < 300).length,
    sessionsSansFinalize: sessions.filter((session) => !session.hasFinalize).length,
  };
}

function percentile(valeurs, ratio) {
  if (!valeurs.length) return 0;
  const index = Math.min(valeurs.length - 1, Math.max(0, Math.ceil(valeurs.length * ratio) - 1));
  return valeurs[index];
}

function serialiserSignalSession(signal) {
  const ts = signal.timestampMs || timestampMs(signal.at) || timestampMs(signal.timestamp);
  if (!ts) return null;
  return {
    type: signal.type,
    at: new Date(ts).toISOString(),
    cameraId: signal.cameraId,
    driftSec: signal.driftSec,
    payload: signal.payload || {},
    projectionCanonique: {
      type: signal.type,
      at: new Date(ts).toISOString(),
      cameraId: signal.cameraId,
      driftSec: signal.driftSec,
      payload: signal.payload || {},
    },
  };
}

function calculerMetricsAv(auditsAv) {
  const ordonnes = [...auditsAv].sort((a, b) => timestampMs(a.at) - timestampMs(b.at));
  const premier = ordonnes[0];
  const dernier = ordonnes[ordonnes.length - 1];
  const valeurs = ordonnes.map((signal) => signal.driftSec);
  const maxAbs = valeurs.reduce((selection, valeur) => (Math.abs(valeur) > Math.abs(selection) ? valeur : selection), valeurs[0]);
  const dureeHeures = Math.max(0, (timestampMs(dernier.at) - timestampMs(premier.at)) / 3600000);
  const pente = dureeHeures > 0 ? (dernier.driftSec - premier.driftSec) / dureeHeures : 0;
  const nature = qualifierNatureAv(ordonnes, pente);

  return {
    driftDebutSec: arrondirSec(premier.driftSec),
    driftFinSec: arrondirSec(dernier.driftSec),
    driftMaxSec: arrondirSec(maxAbs),
    penteSecParHeure: arrondirSec(pente),
    nature,
    impact: Math.abs(maxAbs) >= SEUIL_DERIVE_AV_IMPACT_CLIENT_SEC
      ? 'clips fin seance potentiellement decales'
      : 'impact non calculable',
  };
}

function qualifierNatureAv(auditsAv, pente) {
  const nature = [];
  if (auditsAv.length >= 2 && Math.abs(pente) >= 1) nature.push('progressive');

  const valeurs = auditsAv.map((signal) => signal.driftSec);
  const amplitude = valeurs.length > 0
    ? Math.max(...valeurs) - Math.min(...valeurs)
    : 0;
  const variations = [];
  for (let i = 1; i < valeurs.length; i += 1) {
    variations.push(valeurs[i] - valeurs[i - 1]);
  }
  if (variations.some((variation) => Math.abs(variation) >= 3)) nature.push('sauts');

  const changementsSigne = variations.filter((variation, index) => index > 0 && Math.sign(variation) !== Math.sign(variations[index - 1]) && Math.sign(variation) !== 0).length;
  if (changementsSigne >= 2 && amplitude >= SEUIL_AMPLITUDE_OSCILLATION_AV_SEC) nature.push('oscillante');

  return nature.length > 0 ? nature : ['donnees_insuffisantes'];
}

function rattacherBouclesSession(session, bouclesObservees) {
  return (bouclesObservees || []).filter((boucle) => {
    if (!boucle) return false;
    if (boucle.cameraId && boucle.cameraId !== session.cameraId) return false;
    if (!boucle.debutAt && !boucle.finAt) return !boucle.cameraId;
    const debut = timestampMs(boucle.debutAt || boucle.startAt || boucle.dernierSignalAt);
    const fin = timestampMs(boucle.finAt || boucle.endAt || boucle.dernierSignalAt) || debut;
    const sessionDebut = timestampMs(session.startAt);
    const sessionFin = timestampMs(session.endAt);
    return debut <= sessionFin && fin >= sessionDebut;
  });
}

function resumerSession(session, ouverteEnFinPeriode) {
  const av = session.metrics && session.metrics.av;
  const finalize = session.signaux.finalizeReceived;
  const saine = session.signaux.stopUserConfirmed && session.signaux.finalizeReceived && session.signaux.cameraFinalizeOk;
  const degradee = (av && Math.abs(av.driftMaxSec) >= SEUIL_DERIVE_AV_IMPACT_CLIENT_SEC) || ouverteEnFinPeriode;

  return {
    qualiteGlobale: degradee ? 'degradee' : saine ? 'bonne' : 'donnees_insuffisantes',
    capture: session.signaux.start ? 'Demarrage utilisateur observe.' : 'Demarrage reconstruit apres crash probable.',
    decoupe: finalize ? 'Finalisation recue.' : 'Donnees insuffisantes: finalisation absente dans la periode.',
    transport: 'Donnees insuffisantes',
    temps: av ? `Derive AV max ${formaterSecondes(av.driftMaxSec)}.` : 'Impact non calculable',
  };
}

function diagnostiquerFluxSession(session) {
  return FLUX_INTERPRETES_SESSION.map((flux) => {
    if (flux.id === 'flux:capture-raw') return diagnostiquerCaptureRaw(session, flux);
    if (flux.id === 'flux:av-sync') return diagnostiquerAvSync(session, flux);
    return diagnosticNonInterprete(flux);
  });
}

function diagnostiquerCaptureRaw(session, flux) {
  const preuves = [];
  const contradictions = [];

  if (session.signaux && session.signaux.start) preuves.push('preuve:session_ouverte');
  if ((session.signauxBruts || []).some((signal) => signal.type === 'FIRST_BYTES')) preuves.push('preuve:first_bytes_segment');
  if (session.signaux && session.signaux.cameraFinalizeOk) preuves.push('preuve:camera_finalize_ok');

  const typesContradictoires = {
    CAMERA_FINALIZE_ERREUR: 'preuve:camera_finalize_erreur',
    CAMERA_FINALIZE_VIDE: 'preuve:camera_finalize_vide',
    CAMERA_CRASH: 'preuve:camera_crash',
  };

  (session.signauxBruts || []).forEach((signal) => {
    const preuve = typesContradictoires[signal.type];
    if (preuve && contradictions.indexOf(preuve) < 0) contradictions.push(preuve);
  });

  if (contradictions.length > 0) {
    return diagnosticFlux(flux, {
      etat: 'mission_non_accomplie',
      libelleEtat: 'Mission non accomplie',
      severite: 'rouge',
      raison: raisonCaptureContradiction(contradictions[0]),
      confiance: 'forte',
      preuves,
      contradictions,
    });
  }

  if (preuves.indexOf('preuve:session_ouverte') >= 0
    && preuves.indexOf('preuve:first_bytes_segment') >= 0
    && preuves.indexOf('preuve:camera_finalize_ok') >= 0) {
    return diagnosticFlux(flux, {
      etat: 'mission_accomplie',
      libelleEtat: 'Mission accomplie',
      severite: 'vert',
      raison: 'RAW finalise',
      confiance: 'forte',
      preuves,
      contradictions,
    });
  }

  return diagnosticFlux(flux, {
    etat: 'preuve_insuffisante',
    libelleEtat: 'Preuve insuffisante',
    severite: 'orange',
    raison: raisonCaptureIncomplet(preuves),
    confiance: preuves.length > 0 ? 'moyenne' : 'faible',
    preuves,
    contradictions,
  });
}

function diagnostiquerAvSync(session, flux) {
  const preuves = [];
  const contradictions = [];
  const av = session.metrics && session.metrics.av;
  const deriveTempsReelDetectee = (session.signauxBruts || []).some((signal) => (
    signal.type === 'AV_SYNC_WALL_CLOCK_DRIFT'
    && Number.isFinite(signal.driftSec)
    && Math.abs(signal.driftSec) >= SEUIL_DERIVE_AV_TEMPS_REEL_SEC
  ));
  const deriveImpactClient = av && Math.abs(Number(av.driftMaxSec || 0)) >= SEUIL_DERIVE_AV_IMPACT_CLIENT_SEC;

  if (session.signaux && (session.signaux.finalizeReceived || session.signaux.cameraFinalizeOk)) preuves.push('preuve:segment_finalise_av');
  if (session.metrics && session.metrics.nbAuditsAv > 0) preuves.push('preuve:av_sync_audit');
  if (av) preuves.push('preuve:derive_av_mesuree');
  if (av && (av.nature || []).indexOf('progressive') >= 0) preuves.push('preuve:derive_av_progressive');
  if (av && (av.nature || []).indexOf('sauts') >= 0) preuves.push('preuve:derive_av_sauts');
  if (av && (av.nature || []).indexOf('oscillante') >= 0) preuves.push('preuve:derive_av_oscillante');

  if (deriveTempsReelDetectee) preuves.push('preuve:derive_temps_reel_500ms');
  if (deriveImpactClient) contradictions.push('preuve:derive_av_max_3s');

  if (deriveImpactClient) {
    return diagnosticFlux(flux, {
      etat: 'mission_non_accomplie',
      libelleEtat: 'Mission non accomplie',
      severite: 'rouge',
      raison: 'Derive AV a impact client',
      confiance: 'forte',
      preuves,
      contradictions,
    });
  }

  if (deriveTempsReelDetectee) {
    return diagnosticFlux(flux, {
      etat: 'derive_temps_reel_detectee',
      libelleEtat: 'Surveillance',
      severite: 'orange',
      raison: 'Derive temps reel superieure a 500 ms',
      confiance: 'moyenne',
      preuves,
      contradictions,
    });
  }

  if (av) {
    return diagnosticFlux(flux, {
      etat: 'mission_accomplie',
      libelleEtat: 'Mission accomplie',
      severite: 'vert',
      raison: 'Derive AV mesuree',
      confiance: 'forte',
      preuves,
      contradictions,
    });
  }

  if (preuves.length > 0) {
    return diagnosticFlux(flux, {
      etat: 'preuve_insuffisante',
      libelleEtat: 'Preuve insuffisante',
      severite: 'orange',
      raison: 'Audit AV inexploitable ou absent',
      confiance: 'moyenne',
      preuves,
      contradictions,
    });
  }

  return diagnosticNonInterprete(flux);
}

function diagnosticNonInterprete(flux) {
  return diagnosticFlux(flux, {
    etat: 'non_interprete',
    libelleEtat: 'Non interprete',
    severite: 'gris',
    raison: 'Aucun diagnostic moteur disponible',
    confiance: 'faible',
    preuves: [],
    contradictions: [],
  });
}

function diagnosticFlux(flux, resultat) {
  return {
    type_objet: 'diagnostic_flux_session',
    version_schema: 'diagnostic-flux-session.local.v1',
    flux_id: flux.id,
    nom_flux: flux.nom,
    mission: flux.mission,
    etat: resultat.etat,
    libelle_etat: resultat.libelleEtat,
    severite: resultat.severite,
    raison_principale: resultat.raison,
    confiance: resultat.confiance,
    preuves: resultat.preuves,
    contradictions: resultat.contradictions,
    nb_preuves: (resultat.preuves || []).length,
    nb_contradictions: (resultat.contradictions || []).length,
    affichage: {
      pastille: pastilleSeverite(resultat.severite),
      etat: resultat.libelleEtat,
    },
  };
}

function raisonCaptureContradiction(contradiction) {
  if (contradiction === 'preuve:camera_finalize_vide') return 'RAW vide';
  if (contradiction === 'preuve:camera_finalize_erreur') return 'Erreur de finalisation RAW';
  if (contradiction === 'preuve:camera_crash') return 'Crash camera avant RAW exploitable';
  return 'Preuve contradictoire';
}

function raisonCaptureIncomplet(preuves) {
  if (preuves.indexOf('preuve:session_ouverte') < 0) return 'Session non ouverte';
  if (preuves.indexOf('preuve:first_bytes_segment') < 0) return 'RAW non observe';
  if (preuves.indexOf('preuve:camera_finalize_ok') < 0) return 'RAW non finalise';
  return 'Preuves incompletes';
}

function pastilleSeverite(severite) {
  if (severite === 'vert') return '\u{1F7E2}';
  if (severite === 'rouge') return '\u{1F534}';
  if (severite === 'orange') return '\u{1F7E0}';
  return '\u{26AA}';
}

function lireDriftSec(item, payload, texte) {
  console.warn(
    '[AV_DRIFT_ENTER]',
    {
      itemType: item && item.type,
      payloadKeys: Object.keys(payload || {}),
      texte: String(texte || '').slice(0, 200),
    }
  );

  const direct = lireNombreAvecChamp(item, payload, [
    'driftSec',
    'drift_sec',
    'avDriftSec',
    'av_drift_sec',
    'offsetSec',
    'offset_sec',
    'deltaSec',
    'delta_sec',
    'desyncSec',
    'desync_sec',
  ]);
  if (direct) {
    journaliserDriftParse(direct.champUtilise, direct.valeurBrute, direct.valeurSec);
    console.warn(
      '[AV_DRIFT_RESULT]',
      {
        champUtilise: direct.champUtilise,
        valeurBrute: direct.valeurBrute,
        valeurSec: direct.valeurSec,
      }
    );
    return direct.valeurSec;
  }

  const microsecondes = lireNombreAvecChamp(item, payload, [
    'driftUs',
    'drift_us',
    'avDriftUs',
    'av_drift_us',
    'offsetUs',
    'offset_us',
    'deltaUs',
    'delta_us',
    'avDeltaAtStartUs',
    'avDeltaAtEndUs',
    'driftWithinRawUs',
  ]);
  if (microsecondes) {
    const valeurSec = microsecondes.valeurSec / 1000000;
    journaliserDriftParse(microsecondes.champUtilise, microsecondes.valeurBrute, valeurSec);
    console.warn(
      '[AV_DRIFT_RESULT]',
      {
        champUtilise: microsecondes.champUtilise,
        valeurBrute: microsecondes.valeurBrute,
        valeurSec,
      }
    );
    return valeurSec;
  }

  const matchUs = String(texte || '').match(/(?:driftUs|drift_us|avDriftUs|av_drift_us|offsetUs|offset_us|deltaUs|delta_us)\s*[=:]\s*(-?\d+(?:[.,]\d+)?)/i);
  if (matchUs) {
    const valeurUs = Number(matchUs[1].replace(',', '.'));
    const valeurSec = valeurUs / 1000000;
    if (Number.isFinite(valeurSec)) {
      journaliserDriftParse('texte_us', matchUs[1], valeurSec);
      console.warn(
        '[AV_DRIFT_RESULT]',
        {
          champUtilise: 'texte_us',
          valeurBrute: matchUs[1],
          valeurSec,
        }
      );
      return valeurSec;
    }
  }

  const match = String(texte || '').match(/(?:drift|derive|offset|desync|delta)[^-\d]{0,20}(-?\d+(?:[.,]\d+)?)\s*(?:s|sec|secondes?)/i);
  if (!match) return null;
  const valeurSec = Number(match[1].replace(',', '.'));
  if (Number.isFinite(valeurSec)) journaliserDriftParse('texte', match[1], valeurSec);
  console.warn(
    '[AV_DRIFT_RESULT]',
    {
      champUtilise: 'texte',
      valeurBrute: match[1],
      valeurSec,
    }
  );
  return valeurSec;
}

function lireNombre(item, payload, champs) {
  const resultat = lireNombreAvecChamp(item, payload, champs);
  return resultat ? resultat.valeurSec : null;
}

function lireNombreAvecChamp(item, payload, champs) {
  const resultat = lirePremierChampDetail(item, payload, champs);
  const valeur = resultat.valeur;
  if (valeur === '') return null;
  const nombre = Number(String(valeur).replace(',', '.'));
  return Number.isFinite(nombre)
    ? {
      champUtilise: resultat.champ,
      valeurBrute: valeur,
      valeurSec: nombre,
    }
    : null;
}

function journaliserDriftParse(champUtilise, valeurBrute, valeurSec) {
  console.warn('[AV_DRIFT_PARSE]', {
    champUtilise,
    valeurBrute,
    valeurSec,
  });
}

function lirePremierChamp(item, payload, champs) {
  return lirePremierChampDetail(item, payload, champs).valeur;
}

function lirePremierChampDetail(item, payload, champs) {
  for (let index = 0; index < champs.length; index += 1) {
    const champ = champs[index];
    if (item && item[champ] !== undefined && item[champ] !== null && item[champ] !== '') return { champ, valeur: item[champ] };
    if (payload && payload[champ] !== undefined && payload[champ] !== null && payload[champ] !== '') return { champ, valeur: payload[champ] };
  }
  return { champ: '', valeur: '' };
}

function texteSignal(item, payload) {
  return [
    item.evenement_type,
    item.type_projection,
    item.categorie_operationnelle,
    item.libelle,
    item.message,
    item.contenu_brut,
    item.raw,
    payload ? JSON.stringify(payload) : '',
  ].filter(Boolean).join(' ');
}

function normaliserPayload(payload) {
  if (!payload) return {};
  if (typeof payload === 'object') return payload;
  try {
    return JSON.parse(payload);
  } catch (erreur) {
    return {};
  }
}

function timestampMs(valeur) {
  if (!valeur) return null;
  const date = new Date(valeur);
  return Number.isNaN(date.getTime()) ? null : date.getTime();
}

function arrondirSec(valeur) {
  return Math.round(Number(valeur || 0) * 10) / 10;
}

function formaterSecondes(valeur) {
  const nombre = Number(valeur || 0);
  return `${nombre > 0 ? '+' : ''}${nombre.toFixed(1)} s`;
}

module.exports = {
  calculerSessions,
  calculerStatsSessions,
  collecterSignauxSession,
  consoliderSessions,
  normaliserSignalSession,
};



// WEBPACK FOOTER //
// src/components/cockpit/sessionProjection.js